import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getDashboardGeral } from './services'
import { TResponseDashboardGeral } from './types'

const initialState = {
  status: "",
  data: {}
}

export const actionGetDashboardGeral = createAsyncThunk<TResponseDashboardGeral>(
  "ACTION_GET_DASHBOARD_GERAL",
  async () => {
    const result = await getDashboardGeral()
    console.log("DashboardGeral fetched", result);
    return result
  }
)


const sliceGetDashboardGeral = createSlice({
  name: "GET_DASHBOARD_GERAL",
  initialState,
  reducers: {},
  extraReducers: {
    [`${actionGetDashboardGeral.pending}`]: (state) => {
      state.status = "loading"
    },
    [`${actionGetDashboardGeral.fulfilled}`]: (state, { payload }) => {
      state.status = "success"
      state.data = payload
    },
    [`${actionGetDashboardGeral.rejected}`]: (state) => {
      state.status = "error"
    },
  }
})

export default sliceGetDashboardGeral.reducer